import { Directive, ElementRef, Input, SimpleChanges } from '@angular/core';
import { QueueStatus } from '../api/models';

@Directive({
  selector: '[queueStatusIcon]',
  standalone: true,
})
export class QueueStatusIconDirective {
  @Input('queueStatusIcon') status: QueueStatus;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {
    let classList = 'mdi ';

    switch (this.status) {
      case QueueStatus.Failed:
      case QueueStatus.FailedExtract:
        classList += 'mdi-alert-circle-outline text-danger mdi-21px';
        break;
      case QueueStatus.Ready:
        classList += 'mdi-check-circle-outline text-success mdi-22px';
        break;
      case QueueStatus.Stored:
        classList += 'mdi-content-save-outline text-gray mdi-22px';
        break;
      case QueueStatus.WatingForConfirm:
        classList += 'mdi-lock-reset mdi-22px text-warning mdi-spin';
        break;
      case QueueStatus.WaitingUserConfirmation:
        classList += 'mdi-account-circle mdi-22px text-warning mdi-spin';
        break;
      // case QueueStatus.Confirmed:
      //   classList += "mdi-check-outline text-success mdi-22px"
      //   break;
      // case QueueStatus.Completed:
      //   classList += "mdi-check-bold text-success mdi-22px"
      //   break;
      case QueueStatus.Updating:
        classList += 'mdi-sync mdi-22px text-primary mdi-spin';
        break;
      case QueueStatus.Extracting:
        classList += 'mdi-database-arrow-up-outline mdi-22px text-info';
        break;
      case QueueStatus.Extracted:
        classList += 'mdi-database-arrow-up mdi-22px text-info';
        break;
      case QueueStatus.BeforeAddJob:
        classList += 'mdi-restore-alert mdi-22px text-danger';
        break;
      case QueueStatus.TwentyFivePercentOfExtractingIsDone:
        classList += 'mdi-circle-slice-2 mdi-22px text-info';
        break;
      case QueueStatus.FiftyPercentOfExtractingIsDone:
        classList += 'mdi-circle-slice-4 mdi-22px text-info';
        break;
      case QueueStatus.SeventyFivePercentOfExtractingIsDone:
        classList += 'mdi-circle-slice-6 mdi-22px text-info';
        break;
      case QueueStatus.Calculating:
        classList += 'mdi-calculator-variant-outline mdi-22px text-info';
        break;
      case QueueStatus.CreatingNextScheduledMessage:
        classList += 'mdi-folder-plus-outline mdi-22px text-info';
        break;
      case QueueStatus.CheckSendLimit:
        classList += 'mdi-send-clock mdi-22px text-info';
        break;
      case QueueStatus.CheckWhiteMessage:
        classList += 'mdi-message mdi-22px text-info';
        break;
      case QueueStatus.Rejected:
        classList += 'mdi-close-circle-outline mdi-22px text-danger';
        break;

      default:
        break;
    }

    return classList;
  }
}
